import React from "react";
import "./Sponsors.css";

const Sponsors = () => {
  return (
    <div className="sponsors-container">
      <h1 className="sponsors-title">Our Sponsors</h1>

      <p className="sponsors-message">
        We will be grateful to organizations and individuals who support 
        <strong> Gyanexia </strong> in empowering young minds through learning 
        and competitions. 🤝✨
      </p>
    </div>
  );
};

export default Sponsors;